/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import IssuesTable from '../../components/customTables/tasks/issuesTable';
import SearchHeader from '../../components/searchHeader';

/**
 * Style Imports
 */
import { TaskContainer } from './styles/Employee.styles';

interface IEmployeeIssuesProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const EmployeeIssues: FC<IEmployeeIssuesProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <TaskContainer id="Employee-Issues">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <IssuesTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default EmployeeIssues;
